
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import ConversationStatusViewModel from '@/models/Conversations/ConversationStatusViewModel';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import ListUtils from '@/lib/listUtils';

export default class FilterCampaignSearchViewModel {
    selectedAssignedTo: AgencyUserDto = undefined;
    statuses: ConversationStatusViewModel[] = ListUtils.conversationStatuses();
    selectedStatus: ConversationStatus = undefined;
}